import { useDispatch, useSelector } from "react-redux";
import { ShoppingCart } from "lucide-react";
import {
  selectCartCount,
  selectCartOpen,
  toggleCart,
} from "../../store/cartSlice";

/**
 * CartIcon — navbar button with animated badge.
 * Pulse animation on count change to give tactile feedback.
 */
export default function CartIcon() {
  const dispatch = useDispatch();
  const count = useSelector(selectCartCount);
  const isOpen = useSelector(selectCartOpen);

  return (
    <button
      onClick={() => dispatch(toggleCart())}
      aria-label={`Shopping cart, ${count} item${count !== 1 ? "s" : ""}`}
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 44,
        height: 44,
        borderRadius: 12,
        border: isOpen
          ? "1.5px solid var(--vb-indigo)"
          : "1.5px solid hsl(var(--border))",
        background: isOpen ? "hsl(var(--secondary))" : "transparent",
        cursor: "pointer",
        transition: "all 0.15s ease-out",
        flexShrink: 0,
      }}
    >
      <ShoppingCart
        size={20}
        style={{
          color: isOpen ? "var(--vb-indigo)" : "hsl(var(--foreground))",
          transition: "color 0.15s",
        }}
      />

      {/* Badge */}
      {count > 0 && (
        <span
          key={count}
          style={{
            position: "absolute",
            top: -5,
            right: -5,
            minWidth: 18,
            height: 18,
            borderRadius: 9999,
            background: "var(--vb-indigo)",
            color: "#fff",
            fontSize: 10,
            fontWeight: 700,
            fontFamily: "'DM Mono', monospace",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 4px",
            border: "2px solid #fff",
            animation: "badge-pop 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)",
          }}
        >
          {count > 9 ? "9+" : count}
        </span>
      )}

      <style>{`
        @keyframes badge-pop {
          0% { transform: scale(0.4); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </button>
  );
}
